<template>
  <transaction-row-base :actualAmount="actualAmount"
                        :transactionDate="transactionDate"
                        :transactionDescription="transactionDescription"
                        :isSelected="isSelected"
                        :out-of-date="outOfDate"
                        :is-editable="isEditable"
                        :has-update="hasUpdate"
                        :customer-comment="customerComment"
                        :splitFromTransaction="splitFromTransaction"
                        :is-postponed="isPostponed"
                        :source="source"
                        :transaction="transaction">
    <template v-slot:on-transaction-label>
      <papa-investigation-label v-if="papaInvestigation" :papa-investigation="papaInvestigation"/>
      <high-income-exclusion-label v-else-if="isExcludedHighIncome" :transaction="transaction"/>
    </template>
  </transaction-row-base>
</template>

<script>
import * as _ from 'lodash';
import HighIncomeExclusionLabel
  // eslint-disable-next-line max-len
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/generic-components/cashflow-types/cashflow-types-base/HighIncomeExclusionLabel.vue';
import PapaInvestigationLabel
  // eslint-disable-next-line max-len
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/generic-components/cashflow-types/cashflow-types-base/PapaInvestigationLabel.vue';
import { mapGetters } from 'vuex';
import TransactionDisplayUtils from '../../TransactionDisplayUtils.vue';
import TransactionRowBase from './TransactionRowBase';

export default {
  name: 'TransactionRow',
  mixins: [TransactionDisplayUtils],
  components: {
    HighIncomeExclusionLabel,
    PapaInvestigationLabel,
    TransactionRowBase,
  },
  props: [
    'papaInvestigation',
    'transaction',
    'isEditable',
    'categoryId',
    'isSelected',
    'outOfDate',
    'splitFromTransaction',
  ],
  computed: {
    ...mapGetters('featureFlags', ['showCashflowUpdateIndicators', 'showPostponedTransactions']),
    ...mapGetters('cashflowView', ['transactionsSinceLastActivity']),
    isTransactionEditable() {
      return this.canEditCategory;
    },
    transactionDate() {
      return this.transaction.transactionDate;
    },
    split() {
      return !_.isEmpty(this.transaction.splitFrom);
    },
    customerComment() {
      return this.transaction.customerComment;
    },
    isPostponed() {
      return this.transaction.isPostponed && this.showPostponedTransactions;
    },
    actualAmount() {
      return +this.getTransactionAmountWithoutFraction(this.transaction);
    },
    businessName() {
      return this.transaction.businessName;
    },
    transactionPayment() {
      return this.getTransactionPayment(this.transaction);
    },
    transactionAccount() {
      return this.getTransactionAccount(this.transaction);
    },
    transactionDescription() {
      return `${this.businessName} ${this.transactionPayment} ${this.transactionAccount}`;
    },
    source() {
      return this.transaction.source;
    },
    isExcludedHighIncome() {
      return this.transaction.excludeReason === 'highIncomeExclusion';
    },
    hasUpdate() {
      return this.showCashflowUpdateIndicators && this.transactionsSinceLastActivity.includes(this.transaction.transactionId);
    },
  },
  methods: {
    getTransactionPayment(transaction) {
      return transaction.paymentNumber > 0 ? `- תשלום${transaction.paymentNumber}/${transaction.totalNumberOfPayments}` : '';
    },
  },
};
</script>

<style scoped lang="scss">
@import '~base-ui/src/scss/riseup-colors';
</style>
